export const SECTION_NAMES = {
  CONTRIBUTIONS: 'contributions',
  DISCLOSURE: 'disclosure',
  GIFTS: 'gifts',
  PERFORMANCE: 'performance',
  POTENTIAL: 'potential',
  STOCKS: 'stocks',
}

export const getArticleKey = (section: string): string => {
  switch (section) {
    case SECTION_NAMES.CONTRIBUTIONS:
      return 'early.recap.contributions.about.article_id'
    case SECTION_NAMES.GIFTS:
      return 'early.recap.gifts.about.article_id'
    case SECTION_NAMES.PERFORMANCE:
      return 'early.recap.performance.about.article_id'
    case SECTION_NAMES.POTENTIAL:
      return 'early.recap.potential.about.article_id'
    case SECTION_NAMES.DISCLOSURE:
      return 'early.recap.potential.important_disclosures.article_id'
    // Early Passion delay to 2024
    // https://acorns.atlassian.net/browse/FAM-434
    // case 'stocks':
    //   return 'early.recap.stocks.about.article_id'
    default:
      return ''
  }
}
